import React, { Fragment, useMemo } from 'react';
import AppTable from '../../../constants/AppTable';
import { LoadingSpinner } from '../../../constants/AppLoading';
import { District } from '../../../helpers/models/Models';


interface DistrictListViewProps {
    results: {
        results: District[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnID: (id: number | null) => void;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
}

const DistrictListView: React.FC<DistrictListViewProps> = ({ results, loading, error, setOnID, setOnURL }) => {
    const columns = [
        { header: 'SN', accessor: 'district_id', sortable: false },
        { header: 'Province Name', accessor: 'province_name', sortable: false },
        { header: 'District Name', accessor: 'district_name', sortable: true },
        { header: 'District Name(Nepali)', accessor: 'district_name_nep', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ];

    const modifiedData = useMemo(() => {
        if (!results) return [];
        return results.results.map((item: District) => ({
            district_id: item.district_id,
            province_name: item.province_name,
            district_name: item.district_name,
            district_name_nep: item.district_name_nep,
            actions: (
                <button onClick={() => handleEdit(item)}>Edit</button>
            ),
        }));
    }, [results]);

    const handleEdit = (row: Record<string, any>) => {
        const district = row as District;
        setOnID(district.district_id);
    };
    


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onEdit={handleEdit}
                onNext={() => results?.next && setOnURL(results.next)}
                onPrev={() => results?.previous && setOnURL(results.previous)}
            />
        </Fragment>
    );
};

export default DistrictListView;
